export * from './lib/pois-comparator.module';
export * from './lib/pois-comparator.service';
